var _g;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgSettings = function SvgSettings(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 14 14",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 14,
    height: 14,
    fill: "#FFF",
    opacity: 0
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-.5)"
  }, /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeWidth: 2,
    d: "M7.5,11.7619821 C10.1233526,11.7619821 12.25,9.63533468 12.25,7.01198212 C12.25,4.38862956 10.1233526,2.26198212 7.5,2.26198212 C4.87664744,2.26198212 2.75,4.38862956 2.75,7.01198212 C2.75,9.63533468 4.87664744,11.7619821 7.5,11.7619821 Z"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "currentColor",
    transform: "translate(6)"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: ".5 11 2.5 11 2.5 14 .5 14"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: ".5 0 2.5 0 2.5 3 .5 3"
  })), /*#__PURE__*/React.createElement("g", {
    fill: "currentColor",
    transform: "rotate(-45 4.5 -.243)"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: ".5 11 2.5 11 2.5 14 .5 14"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: ".5 0 2.5 0 2.5 3 .5 3"
  })), /*#__PURE__*/React.createElement("g", {
    fill: "currentColor",
    transform: "rotate(45 4.5 14.243)"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: ".5 11 2.5 11 2.5 14 .5 14"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: ".5 0 2.5 0 2.5 3 .5 3"
  })), /*#__PURE__*/React.createElement("g", {
    fill: "currentColor",
    transform: "rotate(90 4.5 10)"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: ".5 11 2.5 11 2.5 14 .5 14"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: ".5 0 2.5 0 2.5 3 .5 3"
  }))))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgSettings, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/settings.0905ab46.svg";
export { ForwardRef as ReactComponent };